// extracted by mini-css-extract-plugin
export default {"container":"Collapse_container__mAy+G","stile":"Collapse_stile__MJxdf","bodyCon":"Collapse_bodyCon__aFlgk","perso":"Collapse_perso__3ms2O","butoon":"Collapse_butoon__io1Nb"};